import React, { Component } from "react";
import Pagination from "./Pagination";
import upArrow from "./upArrow2.png";
import downArrow from "./downArrow.png";
// import { movies } from "./getMovies";
let genreids = {
  28: "Action",
  12: "Adventure",
  16: "Animation",
  35: "Comedy",
  80: "Crime",
  99: "Documentary",
  18: "Drama",
  10751: "Family",
  14: "Fantasy",
  36: "History",
  27: "Horror",
  10402: "Music",
  9648: "Mystery",
  10749: "Romance",
  878: "Sci-fi",
  10770: "TV",
  53: "Thriller",
  10752: "War",
  37: "Western",
  10759:"Action & Adventure",
  10762:"Kids",
  10763:"News",
  10764:"Reality",
  10765:"Sci-Fi & Fantasy",
  10766:"Soap",
  10767:"Talk",
  10768:"War & Politics"
};

let maxPage;
export default class Favourites extends Component {
  constructor() {
    super();
    
    this.state = {
      currGenre: "All Genres",
      favMovies: [],
      genres:[],
      filteredMovie:[],
      currText:"",
      rows:5,
      currPage:1
    };
  }
  
  async componentDidMount() {
    let m = localStorage.getItem("favourites");
    m = JSON.parse(m);
    await this.setState({
      favMovies: m === null ? [] : [...m],
      filteredMovie: m === null ? [] : [...m],
    });
   
    let temp = this.state.favMovies.map((movie)=>{
    
      return genreids[movie.genre_ids[0]]
    })
    temp = new Set(temp)
    this.setState({
      genres:["All Genres",...temp]
    })

    maxPage = Math.ceil(this.state.filteredMovie.length/this.state.rows)
    // let si = (this.state.currPage - 1) * this.state.rows
    // let li = Number(si) + Number(this.state.rows)
    // this.setState({
    //   filteredMovie: this.state.filteredMovie.slice(si,li)
    // })
  }

  removeFromFavourites = async (movie)=>{
   
    await this.setState({
      favMovies:this.state.favMovies.filter((favMovie)=>{
        // console.log(favMovie.id,movie.id);
        return movie.id!==favMovie.id
      }),
      filteredMovie: this.state.filteredMovie.filter((m)=>{
        return movie.id!==m.id
      })
    })
    
    localStorage.setItem("favourites",JSON.stringify(this.state.favMovies))
    let temp = this.state.favMovies.map((movie)=>{
   
      return genreids[movie.genre_ids[0]]
    })
    temp = new Set(temp)
    this.setState({
      genres:["All Genres",...temp]
    })
  }
  setCurrGenre = async (genre)=>{
    await this.setState({
      currGenre:genre
      })
      this.setState({
        filteredMovie: this.state.currGenre==="All Genres"?this.state.favMovies:this.state.favMovies.filter((movie)=>{
          return genreids[movie.genre_ids[0]]===this.state.currGenre
      }),
        currPage: 1
    })
   
    // filteredMovie = this.state.currGenre==="All Genres"?this.state.favMovies:this.state.favMovies.filter((movie)=>{
    //   return genreids[movie.genre_ids[0]]===this.state.currGenre
    // })
    // console.log(filteredMovie);
  }

  // sorting
  setRating = (val)=>{

    if(val===-1){
      this.setState({
        filteredMovie: this.state.filteredMovie.sort(function(objA,objB){
          return objB.vote_average-objA.vote_average
        })
      })
    }
    else if(val===1){
      this.setState({
        filteredMovie: this.state.filteredMovie.sort(function(objA,objB){
          return objA.vote_average-objB.vote_average
        })
      })
    }
  }

  // sorting
  setPopularity = (val)=>{
   
    if(val===-1){
      this.setState({
        filteredMovie: this.state.filteredMovie.sort(function(objA,objB){
          return objB.popularity-objA.popularity
        })
      })
    }
    else if(val===1){
      this.setState({
        filteredMovie: this.state.filteredMovie.sort(function(objA,objB){
          return objA.popularity-objB.popularity
        })
      })
    }
  }

  // searching
  searchMovie = async (text)=>{
    await this.setState({
      currText:text,
      currPage:1
    })
    this.setState({
      filteredMovie: text===""?this.state.favMovies:[...this.state.favMovies.filter((movie)=>{
        // console.log(movie.title);
       return movie.title?.toLowerCase()?.includes(this.state.currText.toLowerCase())||movie.name?.toLowerCase()?.includes(this.state.currText.toLowerCase())
      })]
    })
    

  }
  
  handlePagination = async (val)=>{
    await this.setState({
      rows: val
    })
    maxPage = Math.ceil(this.state.filteredMovie.length/this.state.rows)
    console.log(val,maxPage);
    // let si = (this.state.currPage - 1) * this.state.rows
    // let li = Number(si) + Number(this.state.rows)
    // console.log(si,li);
    // this.setState({
    //   filteredMovie: this.state.filteredMovie.slice(si,li)
    // })
  }

  onPrev = async ()=>{
    if(this.state.currPage>1){
      await this.setState({
        currPage: this.state.currPage-1
      })
      // let si = (this.state.currPage - 1) * this.state.rows
      // let li = Number(si) + Number(this.state.rows)
      // this.setState({
      //   filteredMovie: this.state.favMovies.slice(si,li)
      // })
    }
  }

  onNext = async ()=>{
    console.log(maxPage);
    if(this.state.currPage<maxPage){
      await this.setState({
        currPage: this.state.currPage+1
      })
      // let si = (this.state.currPage - 1) * this.state.rows
      // let li = Number(si) + Number(this.state.rows)
      
      // this.setState({
      //   filteredMovie: [...this.state.filteredMovie.slice(si,li)]
      // })
    }
  }
  render() {
    // let moviesArr = movies.results
    // console.log("render fav");
    // console.log(genreids[28]);
    // let movies = localStorage.getItem("favourites")
    // movies = JSON.parse(movies)
    // this.setState({
    //   favMovies: [...movies]
    // })
    let si = (this.state.currPage - 1) * this.state.rows
    let li = Number(si) + Number(this.state.rows)
    let f = [...this.state.filteredMovie]
    console.log(f);
    f = [...f.slice(si,li)]
   
    return (
      <>
        <div className="flex justify-center flex-wrap mt-2 px-2">
          {this.state.genres.map((genre)=>{
           return (<button key={genre}
            className={
              this.state.currGenre === genre
                ? "text-lg text-white px-2 bg-blue-400 rounded-xl p-1 m-2"
                : "text-lg text-white px-2 bg-gray-500 hover:bg-blue-400 rounded-xl p-1 m-2"
            } onClick={()=>this.setCurrGenre(genre)}
          >
            {genre}
          </button>)
          })}
          {/* <button
            className={
              this.state.currGenre === "All Genre"
                ? "text-lg text-white px-2 bg-blue-400 rounded-xl p-1 m-2"
                : "text-lg text-white px-2 bg-gray-500 hover:bg-blue-400 rounded-xl p-1 m-2"
            }
          >
            All Genre
          </button> */}
          {/* <button
            className={
              this.state.currGenre === "Action"
                ? "text-lg text-white px-2 bg-blue-400 rounded-xl p-1 m-2"
                : "text-lg text-white px-2 bg-gray-500 hover:bg-blue-400 rounded-xl p-1 m-2"
            }
          >
            Action
          </button> */}
          {/* <button>Action</button> */}
        </div>
        <div className="text-center space-x-4 rounded-xl">
          <input onChange={(e)=>this.searchMovie(e.target.value)}
            value={this.state.currText}
            placeholder="Search"
            type="text"
            className="border-2 text-center m-2 p-1"
          />
          <input onChange={(e)=>this.handlePagination(e.target.value)}
            value={this.state.rows}
            placeholder="Rows"
            type="number"
            className="border-2 text-center m-2 p-1"
          />
        </div>

        <div className="flex flex-col m-4 flex-wrap">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-medium text-center font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs  text-gray-500 uppercase tracking-wider"
                      >
                        <div className="flex justify-center text-medium">
                          <img onClick={()=>this.setRating(1)}
                            className="mr-2 cursor-pointer"
                            src={upArrow}
                            alt="img"
                          />
                          Rating
                          <img onClick={()=>this.setRating(-1)}
                            className="ml-2 cursor-pointer"
                            src={downArrow}
                            alt="img"
                          />
                        </div>
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        <div className="flex justify-center text-medium">
                          <img onClick={()=>this.setPopularity(1)}
                            className="mr-2 cursor-pointer"
                            src={upArrow}
                            alt="img"
                          />
                          Popularity
                          <img onClick={()=>this.setPopularity(-1)}
                            className="ml-2 cursor-pointer"
                            src={downArrow}
                            alt="img"
                          />
                        </div>
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-medium text-center font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Genre
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-medium text-center font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Remove
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {
                     
                    f.map((movie) => (
                      <tr key={movie.id}>
                        <td className="px-14 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div className="flex-shrink-0 ">
                              <img
                                className="h-[5rem] w-[5rem] rounded-full"
                                src={`https://image.tmdb.org/t/p/original/${movie.poster_path}`}
                                alt=""
                              />
                            </div>
                            <div className="ml-4">
                              <div className="text-sm font-medium text-gray-900">
                                {movie.title || movie.name}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="text-sm text-gray-900">
                            {movie.vote_average}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="text-sm text-gray-900">
                            {movie.popularity}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <span
                            className="px-2 inline-flex text-xs leading-5
                      font-semibold rounded-full bg-green-100 text-green-800"
                          >
                            {genreids[movie.genre_ids[0]]}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                          <div onClick={()=>this.removeFromFavourites(movie)} className="text-red-400 hover:text-red-600 text-center cursor-pointer">
                            Delete
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div>
          <Pagination currPage={this.state.currPage} onPrev={this.onPrev} onNext={this.onNext}></Pagination>
        </div>
      </>
    );
  }
}
